@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.tableHeader {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: Constants.$val-spacing-s Constants.$val-spacing-l;
	border: solid 1px Colors.$col-design-grey14;
	border-bottom: none;

	.filters {
		flex: 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}

	.actions {
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;

		.action {
			margin-left: Constants.$val-spacing-s;
		}
	}
}

.rowInEdit {
	background-color: Colors.$col-design-orange5;
	border-bottom: solid 1px Colors.$col-design-orange500;
	border-left: solid 1px Colors.$col-design-orange500;
	border-right: solid 1px Colors.$col-design-orange500;
}

.loadingText {
	text-align: center;
	font-size: Constants.$val-fontSizeBig;
	padding-bottom: Constants.$val-spacing-xxxl;
	padding-top: Constants.$val-spacing-m;
}

.formBox {
	margin-bottom: 0;
}

.bottomElement {
	height: Constants.$val-spacing-xxxl;
}
